import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { useLocale } from '@/hooks/use-locale'
import LotusMark from '@/components/generals/lotus-mark'

const Footer: FC = (): ReactNode => {
    const { locale, t } = useLocale()

    const links = [
        { href: '/', label: t.navHome },
        { href: '/lineage', label: t.navLineage },
        { href: '/story', label: t.navStory },
        { href: '/parva', label: t.navChapters }
    ]

    return (
        <footer className='night-sky text-white/80'>
            <div className='mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-[1.4fr_1fr_1.4fr]'>
                <div>
                    <div className='flex items-center gap-3'>
                        <LotusMark className='size-10' />

                        <div>
                            <p className='font-heading text-2xl font-semibold text-white'>
                                {locale === 'hi' ? 'पद्मपुराण' : 'Padma Purana'}
                            </p>

                            <p className='text-sm text-gold-soft/80'>
                                {t.siteTagline}
                            </p>
                        </div>
                    </div>

                    <h2 className='mt-8 text-sm font-semibold uppercase tracking-[0.16em] text-gold-soft'>
                        {t.footerAbout}
                    </h2>

                    <p className='mt-3 max-w-md text-sm leading-relaxed'>
                        {t.footerAboutBody}
                    </p>
                </div>

                <nav aria-label='Footer'>
                    <h2 className='text-sm font-semibold uppercase tracking-[0.16em] text-gold-soft'>
                        {t.footerExplore}
                    </h2>

                    <ul className='mt-4 space-y-2.5'>
                        {links.map(link => (
                            <li key={link.href}>
                                <Link href={link.href} className='text-sm hover:text-white hover:underline hover:underline-offset-4'>
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div>
                    <div className='gold-rule mb-6 md:hidden' />

                    <p className='text-sm leading-relaxed text-white/70'>
                        {t.footerNote}
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Footer
